import { ElementRef, Injectable } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  // Step 1: Create a BehaviorSubject to store and emit the edited data
  private gridElement!: GridComponent;
  private editedDataSubject = new BehaviorSubject<any[]>([]);
  editedData$ = this.editedDataSubject.asObservable();
  private triggerActionSubject = new Subject<void>(); 
  triggerRestore$ = this.triggerActionSubject.asObservable();
  private positionSource = new BehaviorSubject<number>(0);
  currentPosition$ = this.positionSource.asObservable();


  // Method to update the edited data
  setEditedData(data: any[]) {
    this.editedDataSubject.next(data);
  }
  getEditedData(): any[] {
    return this.editedDataSubject.getValue();
  }

  clearEditedData(): void {
    this.editedDataSubject.next([]);
  }
  triggerGridAction() {
    this.triggerActionSubject.next();
  }
  updatePosition(position: number) {
    this.positionSource.next(position);
  }

  setGridElement(grid: any) {
    this.gridElement = grid;
  }

  getGridPosition(): number {
    return this.gridElement.element.querySelectorAll('.e-movablecontent')[0].scrollLeft || 0;
  }
}
